<div class="d-flex mt-4">
    <p-button
      label="Avbryt"
      class="flex-grow-1 me-3"
      styleClass="w-100"
      severity="secondary"
      (click)="cancel()"
    ></p-button>
    <p-button
      label="Spara"
      class="flex-grow-1"
      styleClass="w-100"
      (click)="ok()"
    ></p-button>
  </div>